module.exports = __webpack_public_path__ + "img/wenti3.09fc070c.png";